export default __webpack_public_path__ + "static/media/Hallticket4.4f55148c.jpg";